module.exports = __webpack_public_path__ + "img/profile02.5a718198.jpg";